module.exports = __webpack_public_path__ + "static/avLogoGreen-e4ddc78eb6f9d3931ae9b5f62c2fcccd.svg";